import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/details/allocated${`?jobId=${number}&workOrderId=${number}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/details/allocated`;

export const URL = (jobId: number, workOrderId: number): RouteDefinition => `${baseRoute}/details/allocated?jobId=${jobId}&workOrderId=${workOrderId}`;
